import type { CustomCellRendererProps } from "ag-grid-react";
import { Flex } from "@unifize/sarah";
import React from "react";
import type { Report } from "src/types";
import ImageLabel from "src/containers/user/ImageLabel/Medium";

interface CellRendererParams extends CustomCellRendererProps {
  data: Report;
}

export const CreatedByCellRenderer = ({
  data,
}: CellRendererParams): React.ReactElement | null => {
  if (!data || !data.creator) return null;

  return (
    <Flex style={{ alignItems: "center", height: "100%", padding: "0 8px" }}>
      <ImageLabel uid={data.creator} />
    </Flex>
  );
};
